import { Loading } from 'components/loading';
import { UpdateEmployeePersonalDetailsInput } from 'features/employees/api/repositories/use-employee-personal-details-update.mutation';
import { FC } from 'react';
import { FieldErrors, FieldNamesMarkedBoolean, UseFormRegister } from 'react-hook-form';

type Props = {
  isLoading: boolean;
  isSubmitting: boolean;
  register: UseFormRegister<UpdateEmployeePersonalDetailsInput>;
  errors: FieldErrors<UpdateEmployeePersonalDetailsInput>;
  touchedFields: Partial<Readonly<FieldNamesMarkedBoolean<UpdateEmployeePersonalDetailsInput>>>;
};

const BankDetails: FC<Props> = ({ isLoading, isSubmitting, register, errors, touchedFields }) => {
  return (
    <div className="card mb-5 mb-xl-10">
      <div
        className="card-header border-0 cursor-pointer"
        role="button"
        data-bs-toggle="collapse"
        data-bs-target="#kt_employee_bank_details"
        aria-expanded="true"
        aria-controls="kt_employee_bank_details"
      >
        <div className="card-title m-0">
          <h3 className="fw-bolder m-0">Bank Details</h3>
        </div>
      </div>

      <div id="kt_form_employee_bank_details" className="collapse show">
        <div className="card-body border-top p-9">
          <div className="row mb-6">
            <div className="col-lg-6 fv-row">
              <label className="col-lg-4 col-form-label fs-6">Bank</label>
              <input
                type="text"
                disabled={isSubmitting || isLoading}
                className="form-control form-control-lg form-control-solid"
                placeholder="Bank name"
                {...register('input.requestBody.bankName')}
              />
              {touchedFields.input?.requestBody?.bankName && errors.input?.requestBody?.bankName && (
                <div className="fv-plugins-message-container">
                  <div className="fv-help-block">{errors.input.requestBody.bankName?.message}</div>
                </div>
              )}
            </div>
            <div className="col-lg-6 fv-row">
              <label className="col-lg-4 col-form-label fs-6">Sort Code</label>
              <input
                type="text"
                disabled={isSubmitting || isLoading}
                className="form-control form-control-lg form-control-solid"
                placeholder="Bank sort code"
                {...register('input.requestBody.bankSortCode')}
              />
              {touchedFields.input?.requestBody?.bankSortCode && errors.input?.requestBody?.bankSortCode && (
                <div className="fv-plugins-message-container">
                  <div className="fv-help-block">{errors.input.requestBody.bankSortCode?.message}</div>
                </div>
              )}
            </div>
          </div>

          <div className="row mb-6">
            <div className="col-lg-6 fv-row">
              <label className="col-lg-4 col-form-label fs-6">Account Number</label>
              <input
                type="text"
                disabled={isSubmitting || isLoading}
                className="form-control form-control-lg form-control-solid"
                placeholder="Bank account number"
                {...register('input.requestBody.bankAccountNo')}
              />
              {touchedFields.input?.requestBody?.bankAccountNo && errors.input?.requestBody?.bankAccountNo && (
                <div className="fv-plugins-message-container">
                  <div className="fv-help-block">{errors.input.requestBody.bankAccountNo?.message}</div>
                </div>
              )}
            </div>
            <div className="col-lg-6 fv-row">
              <label className="col-lg-4 col-form-label fs-6">Payee Name</label>
              <input
                type="text"
                disabled={isSubmitting || isLoading}
                className="form-control form-control-lg form-control-solid"
                placeholder="Bank payee name"
                {...register('input.requestBody.bankPayeeName')}
              />
              {touchedFields.input?.requestBody?.bankPayeeName && errors.input?.requestBody?.bankPayeeName && (
                <div className="fv-plugins-message-container">
                  <div className="fv-help-block">{errors.input.requestBody.message}</div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
      {isLoading && <Loading />}
    </div>
  );
};

export { BankDetails };
